import { SizeCategoryEnum } from "@gtpl/shared-models/common-models";
import { ApiProperty } from "@nestjs/swagger";


export class PalletCapacityDTO {

    @ApiProperty()
    palletCapacityId:number;
    @ApiProperty()
    palletCapacity:number;
    @ApiProperty()
    packingMethodId:number; 
    @ApiProperty()
    packingMethod:string;
    @ApiProperty()
    unitId:number;
    @ApiProperty()
    unitName:string
    @ApiProperty()
    sizeCategory:SizeCategoryEnum;
    @ApiProperty()
    isActive:boolean;
    @ApiProperty()
    createdAt: Date;
    @ApiProperty()
    createdUser: string | null;
    @ApiProperty()
    updatedAt: Date;
    @ApiProperty()
    updatedUser: string | null;
    @ApiProperty()  
    versionFlag: number
   
}
